import { useCallback, useState } from "react";


const useRerender = () => {
  const [, setRenderKey] = useState(0);

  const rerender = useCallback(() => {
    setRenderKey((v) => v + 1);
  }, []);

  return rerender;
};

export default useRerender;
